import React, { Component, Fragment } from 'react';
import URLSearchParams from 'url-search-params';

import { Loading, SERVER_ERROR } from 'commons';
import request from '../request';

class ForgotPassword extends Component {
  state = {
    loading: false,
    email: '',
    error: '',
    recoveryEmailSent: false
  };

  componentDidMount() {
    if (this.props.location.search) {
      const query = this.props.location.search;
      const params = new URLSearchParams(query);
      this.setState({ email: params.get('email') });
    }
  }

  handleEmailChange = e => {
    this.setState({ email: e.target.value });
  };

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({ loading: true });

    try {
      const res = await request('/forgot-password', `email=${encodeURIComponent(this.state.email)}`);

      this.setState({ loading: false });

      if (res.status === 429) {
        this.setState({
          error: 'You have reset password requests pending. Please check your emails.'
        });
        return;
      }
      if (res.status !== 200) {
        this.setState(SERVER_ERROR);
        return;
      }

      const data = await res.json();

      if (data.action === 'success') {
        this.setState({ recoveryEmailSent: true });
      }
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  };

  renderForm() {
    const { recoveryEmailSent, email, error } = this.state;

    if (recoveryEmailSent) {
      return (
        <>
          <p className="invite">
            An email has been sent to <span style={{ fontWeight: 400 }}>{email}</span>
          </p>
          <p className="font-smaller">
            Please check your junk/spam folder if you do not see a Reset Password email in your inbox.
        </p>
        </>
      );
    }

    if (error) {
      return (
        <div className="margin-top-large">{error}</div>
      );
    }
    return (
      <Fragment>
        <p className="invite">Please type your email address to reset your password</p>
        <form className="form-fixed-width-small form-animated" onSubmit={this.handleSubmit}>
          <div className="margin-bottom-large">
            <input
              id="av_email"
              name="av_email"
              placeholder="Email"
              type="email"
              required
              autoFocus
              autoComplete="no"
              value={email}
              onChange={this.handleEmailChange}
            />
          </div>
          <input className="btn" type="submit" value="SEND" />
        </form>
      </Fragment>
    );
  }

  render() {
    const { loading } = this.state;

    if (loading) return <Loading />;

    return (
      <div className="boxed-container">
        {this.renderForm()}
        <div className="margin-top-medium">
          <button className="btnLink" onClick={this.props.history.goBack}>Go Back</button>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
